<template>
  <div class="page-table scrollable">
    <div class="table-box">
      <el-table
        default-expand-all
        :height="tableHeight"
        :data="collection"
        row-key="id"
        ref="cTable"
        style="width: 100%"
        @sort-change="sortChange"
      >
        <el-table-column
          v-for="(col, idx) in columns"
          :key="idx"
          :prop="col.name"
          :label="col.label ? col.label : col.name"
          :width="col.width"
          :min-width="col['min-width']"
          :sortable="col.sortable ? 'custom' : false"
          :class-name="`subtitle2 ${col.datatype === 'number' ? 'justify-end' : ''}`"
        >
          <template slot-scope="scope">
            <div v-if="col.display === 'threathunting'" class="display-inline-block">
              <span class="body1 cursor-pointer threat-hunting" @click="gotoThreatHunting(scope.row, col)">
                {{ scope.row[col.name] }}
                <span
                  class="material-icons"
                  v-if="!$_.isEmpty(scope.row[col.name]) && !$_.isEmpty(col.search)"
                  v-show="insightsEnabled"
                >
                  search
                </span>
              </span>
            </div>

            <div v-else class="display-inline-block">
              <span class="body1">{{ scope.row[col.name] }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="this.tableData.recordsPerPage"
      :total="this.tableData.totalRecords"
      :current-page="this.tableData.currentPage"
      prev-text="PREV"
      next-text="NEXT"
      hide-on-single-page
      style="text-align: center; padding-top: 20px;"
      @current-change="changePage"
    ></el-pagination>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'
import BasicTableElement from '@/components/table/BasicTableElement.vue'

export default {
  name: 'TreeTableElement',
  extends: BasicTableElement,
  props: {
    columns: { type: Array },
    tableData: { type: Object },
    actions: { type: Array },
    uuid: { type: String }
  },
  data () {
    return {
      currentRow: undefined,
      collection: []
    }
  },
  methods: {
    gotoThreatHunting (row, col) {
      // let startTimeHrBefore = moment(row["epochMinutes"]).subtract({ hours: 1 });
      // let startTimeHrAfter = moment(row["epochMinutes"]).add({ hours: 1 });
      if (!this.insightsEnabled) {
        return false
      }

      let threatHuntParam = `date_range:${this.insightsDateRangeUserSetting}`
      let searchCols = _.cloneDeep(col.search)
      for (let searchQueryParam of searchCols) {
        let queryName = searchQueryParam.name
        if (queryName === col.name) {
          searchQueryParam.values = row[col.name]
        }

        if (!_.isEmpty(searchQueryParam.lookupField)) {
          searchQueryParam.values = row[searchQueryParam.lookupField]
        }

        if (_.isEmpty(searchQueryParam.values)) {
          let parentQueryName = `parent${queryName.charAt(0).toUpperCase()}${queryName.slice(1)}`
          searchQueryParam.values = row[queryName] || row[parentQueryName]
        }

        if (_.indexOf(['in', 'not_in'], searchQueryParam.operator) > -1) {
          if (!_.isEmpty(searchQueryParam.queryField)) {
            threatHuntParam += `+${searchQueryParam.queryField}:${
              searchQueryParam.operator
            }:${searchQueryParam.values.join(':')}`
          } else {
            threatHuntParam += `+${searchQueryParam.name}:${searchQueryParam.operator}:${searchQueryParam.values.join(
              ':'
            )}`
          }
        } else if (!_.isEmpty(searchQueryParam.queryField)) {
          threatHuntParam += `+${searchQueryParam.queryField}:${searchQueryParam.operator}:${searchQueryParam.values}`
        } else {
          threatHuntParam += `+${searchQueryParam.name}:${searchQueryParam.operator}:${searchQueryParam.values}`
        }
      }
      this.$router.push({
        name: 'threat-hunting',
        query: { search: threatHuntParam }
      })
    }
  },
  mounted () {
    this.tableHeight = `${this.$el.parentElement.clientHeight - this.heightOffset - 60}`
  },
  computed: {
    ...mapGetters(['insightsDateRangeUserSetting', 'insightsEnabled'])
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/colors.css';

.table-box {
  overflow: auto;
}

.c-icon {
  margin-right: 0px;
}

.table-action {
  span {
    vertical-align: top;
  }
}

>>> .el-table .cell {
  word-break: break-word;
}

>>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #008044;
  background-color: #dff6ed;
  border-color: #008044;
}

>>> .el-radio-button:last-child {
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #b4214c;
    background-color: #fee5ea;
    border-color: #b4214c;
    box-shadow: -1px 0 0 0 #b4214c;
  }
}

>>> .justify-end {
  text-align: right;
  padding-right: 25px;
}

.threat-hunting {
  .material-icons {
    font-size: 14px;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/table/TreeTableElement.vue